import React, { Dispatch, SetStateAction } from 'react';
import {
	Button,
	IconButton,
	InputAdornment,
	Stack,
	TextField,
	Typography,
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Close, Search } from '@mui/icons-material';

const AccessoriesToolbar: React.FC<{
	searchInput: string;
	setSearchInput: Dispatch<SetStateAction<string>>;
	onRefresh: () => void;
	onAddAccessory: Dispatch<SetStateAction<boolean>>;
}> = ({ searchInput, setSearchInput, onRefresh, onAddAccessory }) => {
	return (
		<Stack>
			<Stack
				sx={{
					flexDirection: 'row',
					justifyContent: 'space-between',
					alignItems: 'center',
				}}
			>
				<Stack>
					<Typography fontWeight="bold">Accessories</Typography>
					<Typography fontSize="13px" color="gray.500">
						Configure accessories and their pricing formulas
					</Typography>
				</Stack>

				<Stack
					sx={{
						flexDirection: 'row',
						justifyContent: 'space-between',
						alignItems: 'center',
						gap: '15px',
					}}
				>
					<TextField
						sx={{
							width: {
								xs: '100px',
								sm: '180px',
								md: '220px',
								lg: '260px',
							},
						}}
						aria-label="Search"
						placeholder="Search accessories"
						size="small"
						variant="outlined"
						value={searchInput}
						onChange={(e) => {
							setSearchInput(e.target.value);
						}}
						slotProps={{
							input: {
								startAdornment: (
									<InputAdornment
										position="start"
										sx={{
											marginLeft: '-10px',
										}}
									>
										<Search fontSize="small" />
									</InputAdornment>
								),
								endAdornment: (
									<InputAdornment
										position="start"
										sx={{
											marginRight: '-10px',
										}}
									>
										<IconButton onClick={() => setSearchInput('')}>
											<Close fontSize="small" />
										</IconButton>
									</InputAdornment>
								),
							},
						}}
					/>

					<IconButton
						onClick={onRefresh}
						sx={{
							color: 'gray.500',
							border: '1px dotted',
							borderColor: 'gray.500',
							'&:hover': {
								borderColor: 'primary.main',
								color: 'primary.main',
							},
						}}
					>
						<RefreshIcon />
					</IconButton>

					<Button
						sx={{ backgroundColor: 'primary.main', color: 'white' }}
						onClick={onAddAccessory}
					>
						Add New Accessory
					</Button>
				</Stack>
			</Stack>
		</Stack>
	);
};

export default AccessoriesToolbar;
